import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Menu from './components/layout/Menu';
import Footer from './components/layout/Footer';

const Home = lazy(() => import('./pages/Home'));
const Nosotros = lazy(() => import('./pages/Nosotros'));
const Portafolio = lazy(() => import('./pages/Portafolio'));
const Contacto = lazy(() => import('./pages/Contacto'));
const SeoPage = lazy(() => import('./pages/SeoPage'));
const Perfil = lazy(() => import('./pages/Perfil'));
const CambiarContrasena = lazy(() => import('./pages/CambiarContrasena'));
const Soporte = lazy(() => import('./pages/Soporte'));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Menu />
        <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="w-12 h-12 border-4 border-[#f26724] border-t-transparent rounded-full animate-spin" /></div>}>
          <Routes>
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/inicio" element={<Home />} />
            <Route path="/portafolio" element={<Portafolio />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/cambiar-contrasena" element={<CambiarContrasena />} />
            <Route path="/soporte" element={<Soporte />} />
            <Route path="/pagina/:slug" element={<SeoPage />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
